module.exports = __webpack_public_path__ + "img/simpleui_projector_lx_up.28647257.png";